import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import Tippy from '@tippyjs/react';
import { CustomRangeSlider } from '../CustomRangeSlider/CustomRangeSlider';
/**
 * Bronson CustomProgress component.
 *
 * @see https://bronson.vwfs.io/default/components/detail/bronson-custom-progress.html
 *
 * @constructor
 */
export function CustomProgress({ className, connect, detailsLeft, detailsRight, range, steps, theme, testId, ...otherProps }) {
    const [rangeSliderRef, setRangeSliderRef] = useState(null);
    const [tooltipRefs, setTooltipRefs] = useState([]);
    const classNameList = classNames('c-custom-progress', className).trim();
    useEffect(() => {
        if (rangeSliderRef?.current && tooltipRefs.length < 1 && steps) {
            const thumbs = Array.from(rangeSliderRef?.current?.target?.querySelectorAll('.c-custom-progress__thumb')) ?? [];
            const triggerTargets = Array.from(rangeSliderRef?.current?.target?.querySelectorAll('.c-custom-progress__connect')) ?? [];
            /**
             * Iterate of the thumbs and inject an icon where configured.
             */
            thumbs.forEach((thumb, i) => {
                const iconName = steps?.[i].icon;
                if (iconName) {
                    thumb?.insertAdjacentHTML('beforeend', `<i class="c-custom-progress__thumb__icon c-icon c-icon--[${iconName}]" aria-hidden="true"></i>`);
                }
            });
            setTimeout(() => setTooltipRefs(thumbs.map((h, i) => (React.createElement(Tippy, { content: steps[i]?.tooltip?.content, key: `renderTooltips-${i}`, reference: h, trigger: steps[i]?.tooltip?.trigger ?? 'manual', triggerTarget: triggerTargets[i] ?? null, showOnCreate: steps[i]?.tooltip?.trigger !== 'mouseenter', appendTo: rangeSliderRef?.current?.target, placement: steps[i]?.tooltip?.placement ?? 'top', hideOnClick: false, maxWidth: "none", allowHTML: true, onCreate: () => {
                    const isStatic = steps[i]?.tooltip?.trigger !== 'mouseenter';
                    const placementDirection = steps[i]?.tooltip?.placement ?? 'top';
                    /**
                     * Add positional classes to the thumb and trigger element.
                     */
                    thumbs[i]?.classList.add(`c-custom-progress__tooltip-placement--${placementDirection}`);
                    triggerTargets[i]?.classList.add(`c-custom-progress__tooltip-placement--${placementDirection}`);
                    /**
                     * Static and non-final thumbs get a special class.
                     */
                    if (isStatic && !steps[i]?.final) {
                        thumbs[i]?.classList.add('c-custom-progress__step--main');
                        triggerTargets[i]?.classList.add('c-custom-progress__step--main');
                    }
                }, popperOptions: {
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                enable: false,
                                enabled: false,
                                flipVariations: false,
                                /**
                                 * This disables the flip behavior.
                                 * @see https://popper.js.org/docs/v2/modifiers/flip/#fallbackplacements
                                 */
                                fallbackPlacements: [],
                            },
                        },
                    ],
                } })))), 150);
        }
    }, [rangeSliderRef, steps, tooltipRefs]);
    const customRangeSliderValue = steps?.map((s) => s.value);
    const renderSlider = () => (React.createElement(CustomRangeSlider, { className: "c-custom-progress__visualization", sliderInstanceRef: (ref) => setRangeSliderRef(ref), range: range, value: customRangeSliderValue, connect: connect, disabled: true, "aria-hidden": "true", tabIndex: -1, noUiSliderOpts: { cssPrefix: 'c-custom-progress', keyboardSupport: false }, "data-custom-progress-theme": theme }));
    const renderDescription = () => (React.createElement("div", { className: "c-custom-progress__description" },
        detailsLeft && (React.createElement("div", { className: "c-custom-progress__description__item c-custom-progress__description__item--start" }, detailsLeft)),
        detailsRight && (React.createElement("div", { className: "c-custom-progress__description__item c-custom-progress__description__item--end" }, detailsRight))));
    return (React.createElement("div", { className: classNameList, "data-testid": testId, ...otherProps },
        tooltipRefs,
        renderSlider(),
        renderDescription()));
}
